export default __webpack_public_path__ + "228475bf84b448adc5ed0205fffd8a21.svg";